import React from "react";
import {
  consumeApi,
  getTokens,
  setLiteral,
  removeHtmlTags,
} from "../js/helpers.js";
import {
  Page,
  Navbar,
  NavRight,
  Link,
  LoginScreen,
  LoginScreenTitle,
  List,
  ListInput,
  Button,
  Row,
  Col,
  f7,
  Block,
} from "framework7-react";
import Framework7, { Dom7, getDevice } from "framework7";
import packageJson from "../../package.json";

export default class Nregistro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Identification: "",
      userInformation: null,
      configDomain: props.configDomain || { id_empresa: "", id_idioma: "" },
      lsLiterales: props.lsLiterales || {},
      isLoading: false,
      error: null,
      idCli: null,
    };
    this.validateIdentification = this.validateIdentification.bind(this);

    this.$$ = Dom7;
  }

  componentDidMount() {
    if (!this.state.configDomain.id_empresa) {
      this.getConfiguration();
    }
  }

  getConfiguration = async () => {
    const sHost = window.location.hostname;
    const method = "/security/InfoDomain/ConfigByDomain/" + sHost;

    try {
      const configuration = await consumeApi("GET", method, "");
      await getTokens(parseInt(configuration.id_empresa));
      this.$$("body").addClass("color-theme-" + configuration.id_empresa);
      this.setState({ configDomain: configuration });
      this.getLiterales();
    } catch (error) {
      console.error("Error al obtener configuración:", error);
      f7.dialog.alert("Error al cargar la configuración");
    }
  };

  getLiterales = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
    try {
      const method =
        "/miapp/MiApp/Literal/" +
        this.state.configDomain.id_empresa +
        "/" +
        this.state.configDomain.id_idioma;
      const lsLiterales = await consumeApi("GET", method, "");
      this.setState({ lsLiterales: lsLiterales });
    } catch (error) {
      console.error("Error al obtener literales:", error);
      f7.dialog.alert("Error al cargar textos");
    } finally {
      f7.dialog.close();
    }
  };

  validateIdentification = async (e) => {
    e?.preventDefault();

    if (!this.state.Identification.trim()) {
      f7.dialog.alert("Por favor, ingresa tu identificación");
      return;
    }

    this.setState({ isLoading: true });
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));

    try {
      // 1. Obtener ID de cliente
      const clientData = await this.getClientIdByRFC();

      // Actualizar el estado con idCli
      this.setState({ idCli: clientData });

      // 2. Obtener datos completos del usuario
      const userData = await this.getUserData(clientData.IdCliente);

      if (userData.active === "1") {
        f7.dialog.close();
        f7.dialog.alert(
          removeHtmlTags(setLiteral(this.state.lsLiterales, 101094))
        );
        this.setState({ isLoading: false });
        this.setState({ userInformation: userData });
      } else {
        f7.dialog.close();
        this.props.f7router.navigate("/registro2/", {
          props: {
            userData: userData,
            lsLiterales: this.state.lsLiterales,
            configDomain: this.state.configDomain,
            clienteID: clientData,
          },
        });
      }
    } catch (error) {
      f7.dialog.close();
      f7.dialog.alert(
        error.message || "Ocurrió un error al validar tu identificación"
      );
      this.setState({ isLoading: false });
    }
  };

  getUserData = async (clientId) => {
    const method = "/miapp/User/UserData/";

    // Primero intentamos con option 1 (datos completos)
    let params = {
      company: this.state.configDomain.id_empresa,
      clientId: clientId,
      option: "1",
      applicationType: "1",
    };
    let response = await consumeApi("POST", method, JSON.stringify(params));
    // Si obtenemos datos válidos
    if (response && response.clientId) {
      return response;
    }
    //1107078664
    // Si no, intentamos con option 3
    params.option = "3";
    response = await consumeApi("POST", method, JSON.stringify(params));
    if (!response || !response.full_name) {
      throw new Error("No se encontraron datos del usuario");
    }

    return response;
  };
  // Dentro de tu componente Nregistro2:
  getClientIdByRFC = async () => {
    const method = `/miapp/User/GetIdClienteByRFC/${this.state.configDomain.id_empresa}/${this.state.Identification}`;
    try {
      const response = await consumeApi("GET", method, "");

      // Si la respuesta es un string, verificamos si es JSON válido
      if (typeof response === "string") {
        try {
          // Intentamos parsear como JSON
          const parsedResponse = JSON.parse(response);

          // Si tiene IdCliente, es una respuesta válida
          if (parsedResponse.IdCliente) {
            return parsedResponse;
          }

          // Si no tiene IdCliente pero tiene error
          if (parsedResponse.error) {
            throw new Error(
              parsedResponse.message ||
                setLiteral(this.state.lsLiterales, 101069)
            );
          }
        } catch (e) {
          // Si no se puede parsear, verificamos si es un mensaje de error
          if (
            response.includes("Not found data") ||
            response.includes("error")
          ) {
            throw new Error(setLiteral(this.state.lsLiterales, 101069));
          }
          // Si no es un error conocido, lanzamos el mensaje original
          throw new Error(response);
        }
      }

      // Si la respuesta es un objeto directamente
      if (typeof response === "object") {
        // Respuesta válida con IdCliente
        if (response.IdCliente) {
          return response;
        }
        // Respuesta con error
        if (response.error) {
          throw new Error(
            response.message || setLiteral(this.state.lsLiterales, 101069)
          );
        }
      }

      // Si llegamos aquí, la respuesta no es reconocida
      throw new Error("Respuesta del servidor no válida");
    } catch (error) {
      console.error("Error en getClientIdByRFC:", error);
      throw error; // Re-lanzamos el error para que lo capture validateIdentification
    }
  };

  render() {
    return (
      <Page name="home" className="mainImg">
        <LoginScreen className="LOGIN2" opened={true}>
          <Navbar id="NavReg" transparent={true}>
            <NavRight>
              <Link href="/">X</Link>
            </NavRight>
          </Navbar>
          <LoginScreenTitle className="MC">
            <h2>{setLiteral(this.state.lsLiterales, 101092)}</h2>
          </LoginScreenTitle>
          <List noHairlinesMd>
            <Row className="aligner2">
              <Col width="90">
                <ListInput
                  outline
                  label="Identificación"
                  type="text"
                  placeholder="Ingresa tu identificación"
                  clearButton
                  value={this.state.Identification}
                  onInput={(e) =>
                    this.setState({ Identification: e.target.value })
                  }
                />
              </Col>
            </Row>
            <Row className="aligner3">
              <Col width="100">
                <Button
                  fill
                  className="BtnReg1"
                  onClick={this.validateIdentification}
                >
                  Validar
                </Button>
              </Col>
            </Row>
          </List>
        </LoginScreen>
      </Page>
    );
  }
}
